module.exports = __webpack_public_path__ + "static/DontOpenYourEyes2-8f67f9f48a3f0fa1f8d9d4dba386c920.png";